import React from 'react'
import PropTypes from 'prop-types'
import { CheckBox } from 'components'

import { MoreIcon } from 'assets/images'

import styles from './styles.module.css'

const AddressCard = ({ onAction, item, selected, onSelect }) => {
  return (
    <div className={styles.container}>
      <div className="d-flex">
        <div style={{ marginLeft: 12 }}>
          <CheckBox
            checked={selected}
            onChange={(e) => {
              e.target.checked && onSelect()
            }}
          />
        </div>
        <div className={styles.content}>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <h6>{item.address_name}</h6>
            <div style={{ width: 5 }}>
              <img
                src={MoreIcon}
                onClick={() => onAction({ show: true, data: item })}
              />
            </div>
          </div>
          <p>{item.address}</p>
        </div>
      </div>
    </div>
  )
}

AddressCard.propTypes = {
  onAction: PropTypes.func,
}

AddressCard.defaultProps = {
  onAction: () => {},
}

export default AddressCard
